import { loadCountryRestrictions } from "../loadCountryRestrictions/loadCountryRestrictions";
import { getAddonProductsInCart } from "../../selectors";
import { setCustomerInformationInLocalStorage } from "../setCustomerInformationInLocalStorage/setCustomerInformationInLocalStorage";

export const saveRegistrantInformation = (
  registrantInformation,
  isCustomerSame,
  isSalesOfferSubmission,
) => {
  return async (dispatch, getState, { api }) => {
    const addonProducts = getAddonProductsInCart(getState());

    let tldPersonData = {};
    let dataToSend = {};

    const exchangeProducts = [
      "EXCHANGE_ONLINE",
      "EXCHANGE_M365_BUSINESS_BASIC",
      "EXCHANGE_M365_BUSINESS_STANDARD",
    ];

    const isExchangeAmongAddons = addonProducts.some(({ name }) =>
      exchangeProducts.includes(name),
    );

    const country = registrantInformation["country"].value;
    let isExchangeRestricted = false;

    if (isExchangeAmongAddons) {
      // Check if Exchange is restricterd
      const data = await dispatch(loadCountryRestrictions(country));
      isExchangeRestricted = data.isExchangeRestricted;
    }

    if (isExchangeRestricted) {
      return {
        wasSuccessful: false,
      };
    }

    // User's type depends if Vat or CVR fields are filled out when Company was selected
    if (registrantInformation["type"].value === "organisation_vat") {
      const vatValue =
        registrantInformation["vatNo"] && registrantInformation["vatNo"].value;
      const cvrValue =
        registrantInformation["associationCode"] &&
        registrantInformation["associationCode"].value;

      const isAssosiation = (cvrValue && !vatValue) || (!cvrValue && !vatValue);

      // Customer type depends if either vat or cvr values are provided
      registrantInformation["type"].value = isAssosiation
        ? "organisation_no_vat"
        : "organisation_vat";
    }

    let fields = {
      ...registrantInformation,
      type: {
        // Default to private customer if not set
        ...registrantInformation["type"],
        value: registrantInformation["type"].value || "private",
      },
    };

    dispatch(
      setCustomerInformationInLocalStorage("type", fields["type"].value),
    );

    for (const data in fields) {
      if (fields[data].isRegistrantSpecific) {
        tldPersonData[data] = fields[data].value;
      } else {
        dataToSend[data] = fields[data].value;
      }
    }

    dataToSend = {
      ...dataToSend,
      tldPersonData,
    };

    return api
      .saveRegistrantInformation({ registrantData: dataToSend }, isCustomerSame)
      .then(
        (data) => {
          if (data.result.success) {
            const eidUrl = data.result.eidUrl;

            if (!isSalesOfferSubmission && eidUrl) {
              window.open(`${window.location.origin}${eidUrl}`, "_self");
              return;
            } else {
              return {
                wasSuccessful: true,
              };
            }
          }

          const uniqueTlds = data.result.restrictedTlds
            ? [...new Set(data.result.restrictedTlds)]
            : null;

          return {
            wasSuccessful: false,
            errors: data.result.errors?.map((error) => ({
              name: error.infoFieldName,
              message: error.errorMessage,
            })),
            restrictedTlds: uniqueTlds,
          };
        },
        (err) => {
          return { wasSuccessful: false };
        },
      );
  };
};
